"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import { safeNext } from "@/lib/safeNext";
import { useT } from "@/lib/i18n";

export function LoginForm() {
  const t = useT();
  const router = useRouter();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (res.ok) {
        const next = safeNext(new URLSearchParams(window.location.search).get("next"), "/");
        router.replace(next);
        router.refresh();
        return;
      }
      const d = (await res.json().catch(() => null)) as { error?: string } | null;
      setError(d?.error ?? t("Échec de la connexion."));
    } catch {
      setError(t("Erreur réseau. Réessaie."));
    }
    setLoading(false);
  }

  return (
    <div className="grid min-h-[70vh] place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-xs space-y-5">
        <div className="text-center">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/logo-atlanx.png"
            alt="AtlanX"
            className="mx-auto mb-4 h-20 w-20 rounded-xl object-cover ring-1 ring-border-strong/60"
          />
          <span className="font-display text-2xl font-bold tracking-[0.14em]">
            <span className="text-chrome">ATLAN</span>
            <span className="text-accent">X</span>
          </span>
          <p className="mt-1 text-xs uppercase tracking-wide text-muted">{t("Accès en avant-première")}</p>
        </div>
        <div className="space-y-1.5">
          <label htmlFor="pwd" className="block text-xs font-medium text-fg-dim">
            {t("Mot de passe")}
          </label>
          <input
            id="pwd"
            type="password"
            autoFocus
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-lg border border-border bg-surface px-3 py-2 text-sm text-fg outline-none focus:border-accent"
          />
        </div>
        {error && <p className="text-xs text-bad">{error}</p>}
        <button
          type="submit"
          disabled={loading || !password}
          className="w-full rounded-lg bg-accent py-2 text-sm font-semibold text-on-accent transition-colors hover:bg-accent-hover disabled:opacity-40"
        >
          {loading ? t("Connexion…") : t("Entrer")}
        </button>
      </form>
    </div>
  );
}
